import { withStyles } from '@material-ui/core';

import { Field } from 'formik';
import { isEqual } from 'lodash';
import PropTypes from 'prop-types';
import React, { Component } from 'react';

import { ToggleSelect } from 'modules/intake/form';
import { YES_NO_OPTIONS } from 'utilities/common';
import Log from 'utilities/log';

import styles from 'modules/intake/styles';

class PropertyEscrowForm extends Component {
  shouldComponentUpdate(nextProps) {
    return !isEqual(this.props.escrow, nextProps.escrow);
  }

  render() {
    Log.trace('RENDER', 'PropertyEscrowForm');
    const {
      escrow,
      handleChange,
      handleBlur,
      rootPath,
    } = this.props;

    return (
      <>
        <div className="row">
          <Field
            component={ToggleSelect}
            name={`${rootPath}.isTaxesEscrowed`}
            label="Taxes Escrowed?"
            value={escrow.isTaxesEscrowed}
            onChange={handleChange}
            onBlur={handleBlur}
            options={YES_NO_OPTIONS}
          />
        </div>
        <div className="row">
          <Field
            component={ToggleSelect}
            name={`${rootPath}.isInsuranceEscrowed`}
            label="Insurance Escrowed?"
            value={escrow.isInsuranceEscrowed}
            onChange={handleChange}
            onBlur={handleBlur}
            options={YES_NO_OPTIONS}
          />
        </div>
      </>
    );
  }
}

PropertyEscrowForm.propTypes = {
  escrow: PropTypes.object.isRequired,
  rootPath: PropTypes.string.isRequired,
  handleChange: PropTypes.func.isRequired,
  handleBlur: PropTypes.func.isRequired,
  metadata: PropTypes.object.isRequired,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(PropertyEscrowForm);
